import Vue from 'vue'
import VueI18n from 'vue-i18n'

import App from './App'
import router from './router_config'
import { API } from '@/utils/http'
import store from '@/store'
import '@/utils/message'
import '@/utils/i18n'
import '@/utils/filter'
import '@/common/styles/common.scss'

import enLocale from 'element-ui/lib/locale/lang/en'
import zhCNLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW'
import itLocale from 'element-ui/lib/locale/lang/it'
import idLocale from 'element-ui/lib/locale/lang/id'

import Icon from 'vue-svg-icon/Icon.vue'
// import './registerServiceWorker'

Vue.use(VueI18n)
Vue.component('icon', Icon) // 引用icon
window.API = API

// Create VueI18n instance with options
export const i18n = new VueI18n({
  locale: 'en', // set locale
  messages: {
    en: {
      ...enLocale
    },
    'zh-CN': {
      ...zhCNLocale
    },
    'zh-TW': {
      ...zhTWLocale
    },
    'it': {
      ...itLocale
    },
    'id': {
      ...idLocale
    }
  }
})

// Vue.use(ElementUI, { size: 'small', i18n: (key, value) => i18n.t(key, value) })

export const app = new Vue({
  el: '#app',
  store,
  router,
  i18n,
  render: h => h(App),
  mounted() {
    // You'll need this for renderAfterDocumentEvent.
    /* eslint-disable-next-line */
    console.log('prerender event')
    document.dispatchEvent(new Event('render-event'))
  }
})

export default app
